import styles from './sportlerbar.module.css';
import PersonCard from '../../../components/PersonCard/PersonCard';
import { FussballWidget } from '../../../components/FussballDeWidget/FussballDeWidget';
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadAssignmentsByArea } from '../../../../code/AssignmentPersons';
function Sportlerbar() {
    const [ansprechpartnerPerson, setAnsprechpartnerPerson] = useState(null);
    const color = '--color-red';
    const colorText = '--main-color-white';
    useEffect(() => {
        loadAssignmentsByArea(7, setAnsprechpartnerPerson, color, colorText, true);
    }, []);
    const data = [
        ['Montag:', 'Ruhetag'],
        ['Dienstag - Donnerstag:', 'ab 18:00 Uhr'],
        ['Samstag & Sonntag:', 'je nach Spielbetrieb des TuS 05 Oberpleis e.V. (siehe Matchplan)']
    ]
    const [isOpenVerstaerkung, setIsOpenVerstaerkung] = useState(false);
    const closeAll = () => {
        // fitness und entspannung
        setIsOpenVerstaerkung(false);
    };

    const location = useLocation();
    useEffect(() => {
        // Reset all states
        closeAll();

        // Check hash and update corresponding state
        switch (location.hash.replace("#", "")) {
            case "verstaerkung":
                setIsOpenVerstaerkung(true);
                break;
            default:
                break;
        }
    }, [location.hash]);

    return (
        <section className={styles.container}>
            <h1>Sportlerbar</h1>
            <div className={styles.intro}>
                <div className={styles.left}>
                    {ansprechpartnerPerson && <PersonCard person={ansprechpartnerPerson} />}
                </div>
                <div className={styles.right}>
                    <p>Susanne Lemac und ihr Team freuen sich auf Deinen Besuch in der „Sportlerbar“.</p>
                    <p>Von Dienstag bis Donnerstag ab 18.00 Uhr sowie an den Heimspieltagen werden heiße und kalte Getränke sowie kleine Snacks serviert.</p>
                    <p>Großer Beliebtheit erfreut sich traditionell die „3. Halbzeit“, wenn die Auftritte der TuS-Teams und insbesondere die Trainingseinheiten und Spiele der Alten Herren gebührend analysiert und am Allerliebsten gefeiert werden.</p>
                </div>
            </div>

            <section id='oeffnungszeiten'>
                <h2>Öffnungszeiten</h2>
                <div className={styles.times}><table className={styles.infoTable}>
                    <tbody>
                        {data.map(([label, value], index) => (
                            <tr key={index}>
                                <td className={styles.infoHeader} >{label}</td>
                                <td className={styles.infoValue}>{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table></div>
            </section>

            <section id='matchplan'>
                <h2>Matchplan</h2>
                <FussballWidget isMatchPlan={true} />
            </section>
            {/* <section id='stellenausschreibungen'>
                <h2>Stellenausschreibungen</h2>
                <div id="verstaerkung" className={styles.card}>
                    <div className={styles.title}>
                        <p className={styles.name}>Service- und Thekenkraft (m/w/d)</p>
                        <svg className={`${styles.gt} ${isOpenVerstaerkung ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" onClick={() => setIsOpenVerstaerkung(!isOpenVerstaerkung)}>
                            <title>greater-than</title>
                            <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                        </svg>
                    </div>
                    <div className={`${styles.cardContent} ${isOpenVerstaerkung ? styles.show : styles.hide}`}>
                        <div className={styles.modulContainer}>
                            <div className={styles.mainModul}>
                                <p><strong>Sportlerbar sucht Verstärkung</strong></p>
                                <div className={styles.text}>
                                    <p>Du willst ein junges Team in der Vereinsgastronomie verstärken?</p>
                                    <p>Wir suchen Dich als:</p>

                                </div>
                                <p><strong>Service- und Thekenkraft (m/w/d)</strong></p>
                                <div className={styles.text}>
                                    <p>Wir bieten:</p>
                                    <ul>
                                        <li>Ein junges, dynamisches Team und eine angenehme Arbeitsatmosphäre</li>
                                        <li>Arbeitszeiten überwiegend am Wochenende, tagsüber</li>
                                        <li>Eine Anstellung als Mini-Jobber/in</li>
                                        <li>Arbeitsplatz in Königswinter-Oberpleis</li>
                                    </ul>
                                </div>
                                <p>Wir freuen uns auf Dich!!!</p>
                                <div className={styles.text}>
                                    <p className={styles.red}><strong>sportlerbar</strong></p>
                                    <p>Humboldstraße 3a</p>
                                    <p>53639 Königswinter</p>
                                </div>
                                <div>
                                    <table className={styles.table}>
                                        <tr>
                                            <td>Tel.:</td>
                                            <td>0178 / 40 23 172</td>
                                        </tr>
                                        <tr>
                                            <td>Email:</td>
                                            <td><a href='mailto:s.lemac@gmx.de'>s.lemac@gmx.de</a></td>
                                        </tr>
                                    </table>
                                </div>
                                <a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/BeispielPDF.pdf`} target="_blank" rel="noopener noreferrer">Stellenausschreibung: Service- und Thekenkraft (PDF-Version)</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </section>
    );
}

export default Sportlerbar;